import apiClient from './client';

export interface TierChangePreview {
  current_tier: string;
  new_tier: string;
  current_price: number;
  new_price: number;
  days_remaining: number;
  remaining_value: number;
  new_duration: number;
  new_expires_at: string;
  charge_amount: number;
  is_upgrade: boolean;
  current_expires_at?: string;
  trial_days_granted: number;
  /** Оплата в пробном периоде: сколько его дней закончится (к сроку не добавляются). */
  trial_days_lost?: number;
}

export interface PreviewTierChangeRequest {
  new_tier: string;
}

export interface ConfirmTierChangeRequest {
  preview: TierChangePreview;
}

export interface CreateTierChangePaymentRequest {
  organization_id: string;
  new_tier: string;
  auto_renewal: boolean;
  return_url: string;
}

export interface CreateTierChangePaymentResponse {
  payment_id: string;
  confirmation_url: string;
  status: string;
  /** Прежний незавершённый платёж за ту же смену (второй не создан). */
  reused?: boolean;
}

export interface PaymentStatusResponse {
  id: string;
  status: string;
  amount: number;
  currency: string;
  paid_at?: string;
}

export const tierChangeApi = {
  /**
   * Get preview of tier change with recalculation
   */
  preview: async (organizationId: string, newTier: string): Promise<TierChangePreview> => {
    const response = await apiClient.post<TierChangePreview>(
      `/organizations/${organizationId}/tier-change/preview`,
      { new_tier: newTier } as PreviewTierChangeRequest
    );
    return response.data;
  },

  /**
   * Confirm and apply tier change (for free tier changes / trials)
   */
  confirm: async (organizationId: string, preview: TierChangePreview): Promise<void> => {
    await apiClient.post(
      `/organizations/${organizationId}/tier-change/confirm`,
      { preview } as ConfirmTierChangeRequest
    );
  },

  /**
   * Create a payment for tier change (for paid tier changes)
   */
  createPayment: async (req: CreateTierChangePaymentRequest): Promise<CreateTierChangePaymentResponse> => {
    const response = await apiClient.post<CreateTierChangePaymentResponse>(
      '/payments/tier-change',
      req
    );
    return response.data;
  },

  /**
   * Get payment status by ID (for polling after payment)
   */
  getPaymentStatus: async (paymentId: string): Promise<PaymentStatusResponse> => {
    const response = await apiClient.get<PaymentStatusResponse>(
      `/payments/subscriptions/${paymentId}`
    );
    return response.data;
  },

  /**
   * Check payment status with provider (fallback for missed webhooks)
   */
  checkPaymentWithProvider: async (paymentId: string): Promise<PaymentStatusResponse> => {
    const response = await apiClient.post<PaymentStatusResponse>(
      `/payments/subscriptions/${paymentId}/check`
    );
    return response.data;
  },
};
